<template>
  <div class="home">
    <div class="ui column padded grid centered">
      <div class="row">
        <div class="three wide column"></div>
        <div class="twelve wide column">
          <div class="ui raised padded text segment">
            <h2 class="ui header">Message</h2>

            <vue-markdown>{{ msg }}</vue-markdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserMessages, BaseUrl } from "@/gateway";
import axios from "axios";
import VueMarkdown from "vue-markdown";
export default {
  components: {
    VueMarkdown
  },
  name: "ClientList",
  props: {
    msg: String
  },
  data() {
    return {
      messageMd: "am a ~~tast~~ **test**.",
      results: [],
      searchText: "",
      loading: false,
      totalRecords: 0,
      currentPageNr: 1,
      currentPageSize: 8,
      totalPages: 1
    };
  },
  methods: {
    async getMessage() {
      // var response = await getUserMessages({});
      // console.log(response);
      // this.messageMd = response.htmlMessage;
    }
  },
  mounted: function() {
    //this.getMessage();
  }
};
</script>
